import { useNavigate } from "react-router-dom";
import { useDevice } from "../../hooks";
import { Empty } from "antd";
import { useEffect, useState } from "react";
import { getAllBlog, getAll } from "../../api/blog";
import dayjs from "dayjs";

import {
    ArrowRightOutlined,
    CalendarOutlined,
    DownOutlined
} from "@ant-design/icons";


export default function Blog() {

    const { isMobile } = useDevice();
    const navigate = useNavigate();

    const [blog, setBlog] = useState();
    const [category, setCategory] = useState();

    /*
        Lần đầu tải 15 bài:
        3 bài đầu = bài nổi bật
        12 bài còn lại = bài viết mới

        Bấm "Xem thêm bài viết":
        tải thêm 12 bài.
    */
    const [pageSize, setPageSize] = useState(15);
    const [loadingMore, setLoadingMore] = useState(false);


    /* =================================================
        LẤY DỮ LIỆU BLOG
    ================================================= */

    useEffect(() => {

        const query =
            `page=1&pageSize=${pageSize}`;

        getAllBlog(query, (res) => {

            setBlog(res);
            setLoadingMore(false);

        });

    }, [pageSize]);


    /* =================================================
        LẤY DANH MỤC
    ================================================= */

    useEffect(() => {

        getAll(setCategory);

        window.scrollTo(0, 0);

    }, []);


    /* =================================================
        CHIA BÀI VIẾT
    ================================================= */

    const featuredPosts =
        blog?.data?.slice(0, 3) || [];

    const otherPosts =
        blog?.data?.slice(3) || [];


    /* =================================================
        XÓA HTML TRONG MÔ TẢ
    ================================================= */

    const stripHtml = (html = "") => {

        if (!html) return "";

        const temp =
            document.createElement("div");

        temp.innerHTML = html;

        return (
            temp.textContent ||
            temp.innerText ||
            ""
        );

    };


    /* =================================================
        XEM THÊM BÀI VIẾT
    ================================================= */

    const handleLoadMore = () => {

        if (loadingMore) return;

        setLoadingMore(true);

        setPageSize((prev) => prev + 12);

    };


    const hasMore =
        (blog?.data?.length || 0) <
        (blog?.total || 0);



    return (

        <div
            className="
                min-h-screen
                bg-[#f5f6f8]
                pb-[85px]
            "
        >

            <div
                className="
                    max-w-screen-xl
                    mx-auto

                    px-3
                    md:px-6

                    pt-0
                    md:pt-6
                "
            >


                {/* =================================================
                    BLOG SỨC KHỎE
                ================================================= */}

                <section
                    className="
                        bg-white

                        rounded-2xl

                        border
                        border-gray-100

                        px-4
                        py-3

                        md:px-6
                        md:py-5

                        mb-2.5
                        md:mb-4
                    "
                >

                    <div
                        className="
                            flex
                            items-center
                            gap-3
                        "
                    >

                        <div
                            className="
                                w-[4px]

                                h-[36px]
                                md:h-[44px]

                                flex-none

                                rounded-full

                                bg-[#1677ff]
                            "
                        />


                        <div
                            className="
                                min-w-0
                                flex-1
                            "
                        >

                            <h1
                                className="
                                    text-[20px]
                                    md:text-[28px]

                                    leading-[25px]
                                    md:leading-[34px]

                                    font-bold

                                    text-gray-900
                                "
                            >
                                Blog Sức Khỏe
                            </h1>


                            <p
                                className="
                                    mt-0.5

                                    text-[11px]
                                    md:text-[13px]

                                    leading-[16px]
                                    md:leading-[19px]

                                    text-gray-500
                                "
                            >
                                Kiến thức chăm sóc sức khỏe, phòng bệnh và sống khỏe mỗi ngày
                            </p>

                        </div>

                    </div>

                </section>



                {/* =================================================
                    CHỦ ĐỀ SỨC KHỎE
                ================================================= */}

                {category?.data?.length > 0 && (

                    <section
                        className="
                            bg-white

                            rounded-2xl

                            border
                            border-gray-100

                            mb-2.5
                            md:mb-4

                            py-3
                        "
                    >

                        <div
                            className="
                                px-4

                                mb-2

                                flex
                                items-center
                                justify-between
                            "
                        >

                            <h2
                                className="
                                    text-[14px]
                                    md:text-[17px]

                                    font-bold

                                    text-gray-900
                                "
                            >
                                Chủ đề sức khỏe
                            </h2>


                            <span
                                className="
                                    md:hidden

                                    text-[9px]

                                    text-gray-400
                                "
                            >
                                Vuốt để xem thêm
                            </span>

                        </div>


                        <div
                            className="
                                flex

                                overflow-x-auto

                                gap-2

                                px-4

                                no-scrollbar
                            "
                            style={{
                                scrollbarWidth: "none",
                                WebkitOverflowScrolling: "touch"
                            }}
                        >

                            {category?.data?.map(
                                (item, index) => (

                                    <button
                                        key={
                                            item?.category_blog_slug ||
                                            index
                                        }

                                        type="button"

                                        onClick={() =>
                                            navigate(
                                                `/danh-muc-blog/${item?.category_blog_slug}`
                                            )
                                        }

                                        className="
                                            flex-none

                                            flex
                                            items-center

                                            gap-2

                                            h-[39px]

                                            bg-[#f4f8ff]

                                            border
                                            border-[#e4edfc]

                                            rounded-xl

                                            pl-2
                                            pr-3

                                            transition

                                            hover:bg-[#eaf3ff]
                                        "
                                    >

                                        {item?.category_blog_image && (

                                            <img
                                                src={
                                                    item?.category_blog_image
                                                }

                                                alt={
                                                    item?.category_blog_name
                                                }

                                                className="
                                                    w-[24px]
                                                    h-[24px]

                                                    flex-none

                                                    rounded-lg

                                                    object-cover
                                                "
                                            />

                                        )}


                                        <span
                                            className="
                                                whitespace-nowrap

                                                text-[11px]
                                                md:text-[12px]

                                                font-semibold

                                                text-gray-700
                                            "
                                        >
                                            {item?.category_blog_name}
                                        </span>

                                    </button>

                                )
                            )}

                        </div>

                    </section>

                )}



                {/* =================================================
                    BÀI VIẾT NỔI BẬT
                ================================================= */}

                {featuredPosts.length > 0 && (

                    <section
                        className="
                            bg-white

                            rounded-2xl

                            border
                            border-gray-100

                            p-3
                            md:p-5

                            mb-2.5
                            md:mb-4
                        "
                    >

                        {/* TIÊU ĐỀ */}

                        <div
                            className="
                                flex
                                items-center
                                justify-between

                                mb-3
                                md:mb-4
                            "
                        >

                            <div
                                className="
                                    flex
                                    items-center
                                    gap-2
                                "
                            >

                                <div
                                    className="
                                        w-[4px]
                                        h-[23px]

                                        rounded-full

                                        bg-[#1677ff]
                                    "
                                />


                                <h2
                                    className="
                                        text-[17px]
                                        md:text-[21px]

                                        font-bold

                                        text-gray-900
                                    "
                                >
                                    Bài viết nổi bật
                                </h2>

                            </div>

                        </div>



                        {/* =================================================
                            MOBILE
                        ================================================= */}

                        {isMobile ? (

                            <div>

                                {/* BÀI NỔI BẬT CHÍNH */}

                                {featuredPosts?.[0] && (

                                    <a
                                        href={`/blog/${featuredPosts[0]?.blog_slug}`}

                                        className="
                                            block

                                            overflow-hidden

                                            rounded-2xl

                                            border
                                            border-gray-100

                                            mb-3
                                        "
                                    >

                                        {/* ẢNH */}

                                        <div
                                            className="
                                                relative

                                                w-full
                                                h-[165px]

                                                overflow-hidden

                                                bg-gray-100
                                            "
                                        >

                                            <img
                                                src={
                                                    featuredPosts[0]
                                                        ?.blog_image
                                                }

                                                alt={
                                                    featuredPosts[0]
                                                        ?.blog_name
                                                }

                                                className="
                                                    w-full
                                                    h-full

                                                    object-cover
                                                "
                                            />

                                        </div>


                                        {/* NỘI DUNG */}

                                        <div className="p-3">

                                            <div
                                                className="
                                                    flex
                                                    items-center
                                                    justify-between

                                                    gap-2

                                                    mb-2
                                                "
                                            >

                                                <span
                                                    className="
                                                        min-w-0

                                                        truncate

                                                        text-[10px]

                                                        font-semibold

                                                        text-[#1677ff]
                                                    "
                                                >
                                                    {
                                                        featuredPosts[0]
                                                            ?.category_blog_name
                                                    }
                                                </span>


                                                <span
                                                    className="
                                                        flex-none

                                                        flex
                                                        items-center

                                                        gap-1

                                                        text-[9px]

                                                        text-gray-400
                                                    "
                                                >

                                                    <CalendarOutlined />

                                                    {dayjs(
                                                        featuredPosts[0]
                                                            ?.create_at
                                                    ).format(
                                                        "DD/MM/YYYY"
                                                    )}

                                                </span>

                                            </div>


                                            <h3
                                                className="
                                                    text-[17px]

                                                    leading-[23px]

                                                    font-bold

                                                    text-gray-900
                                                "
                                                style={{
                                                    display: "-webkit-box",
                                                    WebkitBoxOrient: "vertical",
                                                    WebkitLineClamp: 2,
                                                    overflow: "hidden",
                                                    maxHeight: "46px"
                                                }}
                                            >
                                                {
                                                    featuredPosts[0]
                                                        ?.blog_name
                                                }
                                            </h3>


                                            <div
                                                className="
                                                    mt-3

                                                    flex
                                                    justify-end
                                                "
                                            >

                                                <span
                                                    className="
                                                        flex
                                                        items-center

                                                        gap-1

                                                        text-[11px]

                                                        font-semibold

                                                        text-[#1677ff]
                                                    "
                                                >
                                                    Xem bài viết

                                                    <ArrowRightOutlined />

                                                </span>

                                            </div>

                                        </div>

                                    </a>

                                )}



                                {/* BÀI NỔI BẬT 2 + 3 */}

                                {featuredPosts
                                    ?.slice(1)
                                    ?.map((item, index) => (

                                        <a
                                            key={
                                                item?.blog_slug ||
                                                index
                                            }

                                            href={`/blog/${item?.blog_slug}`}

                                            className="
                                                flex

                                                gap-3

                                                py-3

                                                border-t
                                                border-gray-100
                                            "
                                        >

                                            {/* ẢNH */}

                                            <div
                                                className="
                                                    w-[105px]
                                                    h-[75px]

                                                    flex-none

                                                    overflow-hidden

                                                    rounded-xl

                                                    bg-gray-100
                                                "
                                            >

                                                <img
                                                    src={
                                                        item?.blog_image
                                                    }

                                                    alt={
                                                        item?.blog_name
                                                    }

                                                    className="
                                                        w-full
                                                        h-full

                                                        object-cover
                                                    "
                                                />

                                            </div>


                                            {/* NỘI DUNG */}

                                            <div
                                                className="
                                                    min-w-0
                                                    flex-1
                                                "
                                            >

                                                <p
                                                    className="
                                                        text-[9px]

                                                        font-medium

                                                        text-[#1677ff]

                                                        truncate
                                                    "
                                                >
                                                    {
                                                        item
                                                            ?.category_blog_name
                                                    }
                                                </p>


                                                <h3
                                                    className="
                                                        mt-1

                                                        text-[13px]

                                                        leading-[18px]

                                                        font-semibold

                                                        text-gray-900
                                                    "
                                                    style={{
                                                        display: "-webkit-box",
                                                        WebkitBoxOrient: "vertical",
                                                        WebkitLineClamp: 2,
                                                        overflow: "hidden",
                                                        maxHeight: "36px"
                                                    }}
                                                >
                                                    {item?.blog_name}
                                                </h3>


                                                <p
                                                    className="
                                                        mt-1

                                                        flex
                                                        items-center

                                                        gap-1

                                                        text-[9px]

                                                        text-gray-400
                                                    "
                                                >

                                                    <CalendarOutlined />

                                                    {dayjs(
                                                        item?.create_at
                                                    ).format(
                                                        "DD/MM/YYYY"
                                                    )}

                                                </p>

                                            </div>

                                        </a>

                                    ))}

                            </div>

                        ) : (

                            /* =================================================
                                DESKTOP
                                3 BÀI NỔI BẬT
                            ================================================= */

                            <div
                                className="
                                    grid
                                    grid-cols-3
                                    gap-4
                                "
                            >

                                {featuredPosts.map(
                                    (item, index) => (

                                        <a
                                            key={
                                                item?.blog_slug ||
                                                index
                                            }

                                            href={`/blog/${item?.blog_slug}`}

                                            className="
                                                group

                                                block

                                                overflow-hidden

                                                rounded-2xl

                                                border
                                                border-gray-100

                                                bg-white

                                                transition-all

                                                hover:shadow-lg
                                            "
                                        >

                                            {/* ẢNH */}

                                            <div
                                                className="
                                                    relative

                                                    aspect-[16/9]

                                                    overflow-hidden

                                                    bg-gray-100
                                                "
                                            >

                                                <img
                                                    src={
                                                        item?.blog_image
                                                    }

                                                    alt={
                                                        item?.blog_name
                                                    }

                                                    className="
                                                        w-full
                                                        h-full

                                                        object-cover

                                                        transition-transform
                                                        duration-300

                                                        group-hover:scale-[1.03]
                                                    "
                                                />


                                                {index === 0 && (

                                                    <span
                                                        className="
                                                            absolute

                                                            left-3
                                                            bottom-3

                                                            bg-white/95

                                                            px-3
                                                            py-1.5

                                                            rounded-lg

                                                            text-[10px]

                                                            font-bold

                                                            text-[#1677ff]

                                                            shadow-sm
                                                        "
                                                    >
                                                        Nổi bật
                                                    </span>

                                                )}

                                            </div>


                                            {/* NỘI DUNG */}

                                            <div className="p-4">

                                                <div
                                                    className="
                                                        flex
                                                        items-center
                                                        justify-between

                                                        gap-2

                                                        mb-2
                                                    "
                                                >

                                                    <span
                                                        className="
                                                            min-w-0

                                                            truncate

                                                            text-[10px]

                                                            font-semibold

                                                            text-[#1677ff]
                                                        "
                                                    >
                                                        {
                                                            item
                                                                ?.category_blog_name
                                                        }
                                                    </span>


                                                    <span
                                                        className="
                                                            flex-none

                                                            flex
                                                            items-center

                                                            gap-1

                                                            text-[9px]

                                                            text-gray-400
                                                        "
                                                    >

                                                        <CalendarOutlined />

                                                        {dayjs(
                                                            item?.create_at
                                                        ).format(
                                                            "DD/MM/YYYY"
                                                        )}

                                                    </span>

                                                </div>


                                                <h3
                                                    className="
                                                        text-[17px]

                                                        leading-[23px]

                                                        font-bold

                                                        text-gray-900

                                                        group-hover:text-[#1677ff]

                                                        transition-colors
                                                    "
                                                    style={{
                                                        display: "-webkit-box",
                                                        WebkitBoxOrient: "vertical",
                                                        WebkitLineClamp: 2,
                                                        overflow: "hidden",
                                                        height: "46px"
                                                    }}
                                                >
                                                    {item?.blog_name}
                                                </h3>


                                                <p
                                                    className="
                                                        mt-2

                                                        text-[12px]

                                                        leading-[18px]

                                                        text-gray-500
                                                    "
                                                    style={{
                                                        display: "-webkit-box",
                                                        WebkitBoxOrient: "vertical",
                                                        WebkitLineClamp: 2,
                                                        overflow: "hidden",
                                                        height: "36px"
                                                    }}
                                                >
                                                    {stripHtml(
                                                        item?.blog_description
                                                    )}
                                                </p>


                                                <div
                                                    className="
                                                        mt-3

                                                        flex
                                                        justify-end
                                                    "
                                                >

                                                    <span
                                                        className="
                                                            flex
                                                            items-center

                                                            gap-1

                                                            text-[11px]

                                                            font-semibold

                                                            text-[#1677ff]
                                                        "
                                                    >
                                                        Đọc tiếp

                                                        <ArrowRightOutlined />

                                                    </span>

                                                </div>

                                            </div>

                                        </a>

                                    )
                                )}

                            </div>

                        )}

                    </section>

                )}



                {/* =================================================
                    BÀI VIẾT MỚI
                ================================================= */}

                <section
                    className="
                        bg-white

                        rounded-2xl

                        border
                        border-gray-100

                        px-3
                        py-3.5

                        md:p-6
                    "
                >

                    {/* HEADER */}

                    <div
                        className="
                            flex
                            items-center
                            justify-between

                            mb-1
                            md:mb-4
                        "
                    >

                        <div
                            className="
                                flex
                                items-center
                                gap-2
                            "
                        >

                            <div
                                className="
                                    w-[4px]
                                    h-[24px]

                                    rounded-full

                                    bg-[#1677ff]
                                "
                            />


                            <h2
                                className="
                                    text-[17px]
                                    md:text-[21px]

                                    font-bold

                                    text-gray-900
                                "
                            >
                                Bài viết mới
                            </h2>

                        </div>


                        <span
                            className="
                                text-[10px]
                                md:text-[12px]

                                text-gray-400
                            "
                        >
                            {blog?.total || 0} bài
                        </span>

                    </div>



                    {/* =================================================
                        MOBILE LIST
                    ================================================= */}

                    {isMobile ? (

                        <div>

                            {otherPosts.length > 0 ? (

                                otherPosts.map(
                                    (item, index) => (

                                        <a
                                            key={
                                                item?.blog_slug ||
                                                index
                                            }

                                            href={`/blog/${item?.blog_slug}`}

                                            className="
                                                flex

                                                gap-3

                                                py-3

                                                border-b
                                                border-gray-100

                                                last:border-b-0
                                            "
                                        >

                                            {/* ẢNH */}

                                            <div
                                                className="
                                                    w-[105px]
                                                    h-[75px]

                                                    flex-none

                                                    overflow-hidden

                                                    rounded-xl

                                                    bg-gray-100
                                                "
                                            >

                                                <img
                                                    src={
                                                        item?.blog_image
                                                    }

                                                    alt={
                                                        item?.blog_name
                                                    }

                                                    className="
                                                        w-full
                                                        h-full

                                                        object-cover
                                                    "
                                                />

                                            </div>


                                            {/* NỘI DUNG */}

                                            <div
                                                className="
                                                    flex-1

                                                    min-w-0

                                                    flex
                                                    flex-col
                                                "
                                            >

                                                <h3
                                                    className="
                                                        text-[13px]

                                                        leading-[18px]

                                                        font-semibold

                                                        text-gray-900
                                                    "
                                                    style={{
                                                        display: "-webkit-box",
                                                        WebkitBoxOrient: "vertical",
                                                        WebkitLineClamp: 2,
                                                        overflow: "hidden",
                                                        maxHeight: "36px"
                                                    }}
                                                >
                                                    {item?.blog_name}
                                                </h3>


                                                <p
                                                    className="
                                                        mt-1

                                                        truncate

                                                        text-[10px]

                                                        leading-[14px]

                                                        font-medium

                                                        text-[#1677ff]
                                                    "
                                                >
                                                    {
                                                        item
                                                            ?.category_blog_name
                                                    }
                                                </p>


                                                <div
                                                    className="
                                                        mt-auto

                                                        flex
                                                        items-center

                                                        gap-1

                                                        text-[9px]

                                                        text-gray-400
                                                    "
                                                >

                                                    <CalendarOutlined />

                                                    {dayjs(
                                                        item?.create_at
                                                    ).format(
                                                        "DD/MM/YYYY"
                                                    )}

                                                </div>

                                            </div>

                                        </a>

                                    )
                                )

                            ) : (

                                <div className="py-10">

                                    <Empty
                                        description="Chưa có bài viết"
                                    />

                                </div>

                            )}

                        </div>

                    ) : (

                        /* =================================================
                            DESKTOP GRID
                        ================================================= */

                        <div
                            className="
                                grid

                                grid-cols-2
                                lg:grid-cols-3

                                gap-5
                            "
                        >

                            {otherPosts.map(
                                (item, index) => (

                                    <a
                                        key={
                                            item?.blog_slug ||
                                            index
                                        }

                                        href={`/blog/${item?.blog_slug}`}

                                        className="
                                            group

                                            bg-white

                                            border
                                            border-gray-100

                                            rounded-2xl

                                            overflow-hidden

                                            transition-all

                                            hover:shadow-lg
                                        "
                                    >

                                        {/* ẢNH */}

                                        <div
                                            className="
                                                aspect-[16/9]

                                                overflow-hidden

                                                bg-gray-100
                                            "
                                        >

                                            <img
                                                src={
                                                    item?.blog_image
                                                }

                                                alt={
                                                    item?.blog_name
                                                }

                                                className="
                                                    w-full
                                                    h-full

                                                    object-cover

                                                    transition-transform
                                                    duration-300

                                                    group-hover:scale-[1.03]
                                                "
                                            />

                                        </div>


                                        {/* NỘI DUNG */}

                                        <div className="p-4">

                                            <p
                                                className="
                                                    mb-2

                                                    truncate

                                                    text-[11px]

                                                    font-semibold

                                                    text-[#1677ff]
                                                "
                                            >
                                                {
                                                    item
                                                        ?.category_blog_name
                                                }
                                            </p>


                                            <h3
                                                className="
                                                    text-[16px]

                                                    leading-[22px]

                                                    font-bold

                                                    text-gray-900

                                                    transition-colors

                                                    group-hover:text-[#1677ff]
                                                "
                                                style={{
                                                    display: "-webkit-box",
                                                    WebkitBoxOrient: "vertical",
                                                    WebkitLineClamp: 2,
                                                    overflow: "hidden",
                                                    height: "44px"
                                                }}
                                            >
                                                {item?.blog_name}
                                            </h3>


                                            <p
                                                className="
                                                    mt-2

                                                    text-[13px]

                                                    leading-[19px]

                                                    text-gray-500
                                                "
                                                style={{
                                                    display: "-webkit-box",
                                                    WebkitBoxOrient: "vertical",
                                                    WebkitLineClamp: 2,
                                                    overflow: "hidden",
                                                    height: "38px"
                                                }}
                                            >
                                                {stripHtml(
                                                    item?.blog_description
                                                )}
                                            </p>


                                            <div
                                                className="
                                                    mt-4

                                                    pt-3

                                                    border-t
                                                    border-gray-100

                                                    flex
                                                    items-center
                                                    justify-between
                                                "
                                            >

                                                <span
                                                    className="
                                                        flex
                                                        items-center

                                                        gap-1

                                                        text-[10px]

                                                        text-gray-400
                                                    "
                                                >

                                                    <CalendarOutlined />

                                                    {dayjs(
                                                        item?.create_at
                                                    ).format(
                                                        "DD/MM/YYYY"
                                                    )}

                                                </span>


                                                <span
                                                    className="
                                                        flex
                                                        items-center

                                                        gap-1

                                                        text-[11px]

                                                        font-semibold

                                                        text-[#1677ff]
                                                    "
                                                >
                                                    Đọc tiếp

                                                    <ArrowRightOutlined />

                                                </span>

                                            </div>

                                        </div>

                                    </a>

                                )
                            )}

                        </div>

                    )}



                    {/* =================================================
                        XEM THÊM BÀI VIẾT
                    ================================================= */}

                    {hasMore && (

                        <div
                            className="
                                flex
                                justify-center

                                mt-6
                                md:mt-8

                                pt-5

                                border-t
                                border-gray-100
                            "
                        >

                            <button
                                type="button"

                                onClick={handleLoadMore}

                                disabled={loadingMore}

                                className="
                                    min-w-[180px]

                                    h-[42px]

                                    px-5

                                    flex
                                    items-center
                                    justify-center

                                    gap-2

                                    rounded-xl

                                    border
                                    border-[#d8e7ff]

                                    bg-[#f4f8ff]

                                    text-[12px]
                                    md:text-[13px]

                                    font-semibold

                                    text-[#1677ff]

                                    transition-all

                                    hover:bg-[#eaf3ff]

                                    disabled:opacity-60
                                "
                            >

                                {loadingMore ? (

                                    <>

                                        <span
                                            className="
                                                w-4
                                                h-4

                                                rounded-full

                                                border-2
                                                border-[#b9d5ff]
                                                border-t-[#1677ff]

                                                animate-spin
                                            "
                                        />

                                        Đang tải...

                                    </>

                                ) : (

                                    <>

                                        Xem thêm bài viết

                                        <DownOutlined />

                                    </>

                                )}

                            </button>

                        </div>

                    )}



                    {/* =================================================
                        ĐÃ XEM HẾT
                    ================================================= */}

                    {!hasMore &&
                        (blog?.data?.length || 0) > 15 && (

                        <div
                            className="
                                mt-6

                                pt-5

                                border-t
                                border-gray-100

                                text-center

                                text-[11px]

                                text-gray-400
                            "
                        >
                            Bạn đã xem hết bài viết
                        </div>

                    )}

                </section>

            </div>

        </div>

    );

}